import skeleton from "./skeleton";
import SkeletonTable from "./skeletonTable";

const Skeleton = Object.assign(skeleton, {
  Table: SkeletonTable,
});

export default Skeleton;
